/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-04-13T04:53:56+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: mobile.filter.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-04-13T05:25:12+03:00
 */
(function($, root) {

  $('.product-solutions .mobile-filter .btn').click(function() {

    if (window.rdo.soln) {
      $(".product-solutions .filters").slideUp();
      window.rdo.soln = false;
    } else {
      $(".product-solutions .filters").slideDown("slow");
      window.rdo.soln = true;
    }

  });
})(jQuery, this);
